interface HeaderLinksProps {
    title: string,
    link: string,
}

export const headerLinks: HeaderLinksProps[] = [
    {
        title: "Akey",
        link: "/",
    },
    {
        title: "Apwopo",
        link: "/about",
    },
    {
        title: "Destinasyon",
        link: "/destination",
    },
    {
        title: "Eksplore",
        link: "/explore",
    },
    {
        title: "Blog",
        link: "/blog",
    },
];